import { cloneDeep } from 'lodash';
import request from 'superagent';
import { setFeedback, delayedClearFeedback, clearFeedback } from './feedback';
import { clearEnrollPaymentSuccess, fireEnrollPaymentSuccess } from './enroll_payment_success';
import { setCustomer } from './customer';
import { setBraintreeFailure, clearBraintreeFailure } from './braintree_failure';

export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS'
export const CLEAR_PAYMENT_METHODS = 'CLEAR_PAYMENT_METHODS'

const initialState = null;

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_PAYMENT_METHODS:
			return [...action.payload];
		case CLEAR_PAYMENT_METHODS:
			return null;
		default:
			return state;
	}
}

export function setPaymentMethods( paymentMethods ){
	return{
		type: SET_PAYMENT_METHODS,
		payload: paymentMethods
	}
}

export function destroyPaymentMethods(){
	return {
		type: CLEAR_PAYMENT_METHODS
	}
}


export function getCustomerPaymentMethods(){
	return dispatch => {
	    request
	      .get('/svc/payments/getCustomerPaymentMethods?time_stamp='+ new Date().getTime())
	      .set({
	        'Content-Type': 'application/json',
	        'Accept': 'application/json'
	      })
	      .end( (err,res) => {
	      	let paymentMethods = JSON.parse( !err && res && res.text ? res.text : [] );
	        if( !err && res.statusCode === 200 && paymentMethods && paymentMethods.length > 0 && paymentMethods[0] ){
          	return dispatch([
          		setPaymentMethods( paymentMethods )
          	]);
	        } else {
	          return dispatch([
	            destroyPaymentMethods(),
	            clearEnrollPaymentSuccess()
	          ]);
	        }
	      });
  	}
}


export function upgradePaymentHelper(finalFunction, failFuction){
	return dispatch => {
	    request
	      .get('/svc/payments/getCustomerPaymentMethods?time_stamp='+ new Date().getTime())
	      .set({
	        'Content-Type': 'application/json',
	        'Accept': 'application/json'
	      })
	      .end( (err,res) => {
	      	let paymentMethods = JSON.parse( !err && res && res.text ? res.text : [] );
	        if( !err && res.statusCode === 200 && paymentMethods && paymentMethods.length > 0 && paymentMethods[0] ){
          	dispatch([
          		fireEnrollPaymentSuccess(),
          		setPaymentMethods( paymentMethods )
          	]);
          	return finalFunction(paymentMethods[0].token);
	        } else {
	        	let sFeedback =  res && res.text ? JSON.parse(res.text).msg : "An error occurred.";
	          dispatch([
	          	setFeedback(sFeedback),
	            destroyPaymentMethods(),
	            setBraintreeFailure( res && res.text ? JSON.parse(res.text).msg : "An error occurred." ),
	            clearEnrollPaymentSuccess()
	          ]);
	          return failFunction();
	        }
	      });
  	}
}


export function addPaymentMethod(oNonce, finalFunction, additionalParams, failFunction ){
    return dispatch => {
	    request
	      .put('/svc/payments/addPaymentMethodHandler')
	      .send({ nonce: oNonce })
	      .set({
	        'Content-Type': 'application/json',
	        'Accept': 'application/json'
	      })
	      .end( (err,res) => {
	        if( !err && res.statusCode === 200 && res && res.text ){
	          let dispatchable = finalFunction(null, JSON.parse(res.text).token, failFunction,  additionalParams );
	          if (dispatchable) dispatch( dispatchable );
	          return dispatch([
	          	getCustomerPaymentMethods(),
	          	clearBraintreeFailure()
	          ]);
	        } else {
	          let sFeedback =  res && res.text ? JSON.parse(res.text).msg : "An error occurred.";
	          failFunction();
	          return dispatch([
	            setFeedback(sFeedback),
	            delayedClearFeedback(),
	            setBraintreeFailure( res && res.text ? JSON.parse(res.text).msg : "An error occurred." )
	          ]);
	        }
	      });
  	}
}

export function updateDefaultPaymentMethod(oNonce, token, finalFunction){
	return dispatch => {
	    request
	      .put('/svc/payments/updateDefaultPaymentMethodHandler')
	      .send({
	        nonce: oNonce,
	        token: token
	      })
	      .set({
	        'Content-Type': 'application/json',
	        'Accept': 'application/json'
	      })
	      .end( (err,res) => {
	        finalFunction();
	        if(err || res.statusCode !== 200){
	        	return dispatch([
		          setFeedback( res && res.text ? JSON.parse(res.text).msg : "An error occurred." ),
		          delayedClearFeedback(),
		          setBraintreeFailure( res && res.text ? JSON.parse(res.text).msg : "An error occurred." )
		        ]);
	        } else {
	        	return dispatch([
		          setFeedback('Your default payment method has been updated.'),
		          delayedClearFeedback(),
		          clearBraintreeFailure()
		        ]);
	        }
	      });
	}
}

export function updatePaymentMethodInfo( updateObj, finalFunction){
	return dispatch => {
	    request
	      .put('/svc/payments/updatePaymentMethodInfoHandler')
	      .send({ updateObj: updateObj })
	      .set({
	        'Content-Type': 'application/json',
	        'Accept': 'application/json'
	      })
	      .end( (err,res) => {
	        finalFunction();
	        if(err || res.statusCode !== 200) {
	        	return dispatch([
		          setFeedback(res && res.text ? JSON.parse(res.text).msg : "An error occurred."),
		          delayedClearFeedback(),
		          setBraintreeFailure( res && res.text ? JSON.parse(res.text).msg : "An error occurred." )
		        ]);
	        } else {
	        	return dispatch([
		          setFeedback("Your payment method has been updated."),
		          delayedClearFeedback(),
		          clearBraintreeFailure()
		        ]);
	        }
	      });
  	}
}

export function deletePaymentMethod(token, finalFunction){
	return dispatch => {
	    request
	      .put('/svc/payments/deletePaymentMethodHandler')
	      .send({
	        token: token
	      })
	      .set({
	        'Content-Type': 'application/json',
	        'Accept': 'application/json'
	      })
	      .end( (err,res) => {
	        finalFunction();
	        let sFeedback = err || res.statusCode !== 200 ? 'Sorry, an error occurred.' : 'Your payment method has been deleted.';
	        return dispatch([
	          setFeedback(sFeedback),
	          delayedClearFeedback()
	        ]);
	      });
  	}
}


// WEBPACK FOOTER //
// ./src/modules/payment_methods.js